"use strict";
// Class definition
var IpixFormValidation = function() {};

IpixFormValidation.handleFormSubmit = function() {
    var submitButtons = [].slice.call(document.querySelectorAll('.fv-button-submit'));

    submitButtons.map(function(submitButton) {
        if (submitButton && $(submitButton).length) {
            submitButton.addEventListener('click', function(e) {
                e.preventDefault();
                IpixJson.validators[$(submitButton).parents("form").attr("id")].validate().then(function(status) {
                    $("a.nav-link").removeClass("tab-pane-error");
                    if (status == 'Valid') {
                        // $(submitButton).parents("form").dirty("setAsClean");
                        submitButton.disabled = true;
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        if (submitButton.getAttribute('data-submit') === "captcha") {
                            const recaptchaSiteKey = submitButton.getAttribute('data-sitekey');
                            grecaptcha.ready(function() {
                                grecaptcha.execute(recaptchaSiteKey, {
                                    action: 'submit'
                                }).then(function(token) {
                                    document.getElementById('g-recaptcha-response').value = token;
                                    $(submitButton).parents("form").submit();
                                });
                            });
                        } else {
                            $(submitButton).parents("form").submit();
                        }
                    } else {
                        if ($(".nav").length) {
                            $("a.nav-link[href='#" + $(".fv-plugins-bootstrap5-row-invalid:first").parents(".tab-pane").attr("id") + "']").addClass('tab-pane-error');
                        }
                        if ($(".accordion").length) {
                            $(".fv-plugins-bootstrap5-row-invalid").parents(".accordion-item").find(".accordion-header h3").addClass('tab-pane-error');
                        }
                    }
                });
            });
        }
    });
}

IpixFormValidation.init = function() {
    IpixFormValidation.handleFormSubmit();
};

IpixUtil.onDOMContentLoaded(function() {
    IpixFormValidation.init();
});

// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = IpixFormValidation;
}
